import { useEffect } from "react";

/** Injects a <script type="application/ld+json"> into <head> while mounted. */
export const useJsonLd = (data) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
